import React from 'react';

import { UiComponent } from 'components';
import { IUserGroupCandidate } from 'types';
import { formatNameWithPhone } from './format';
import * as PickerStyle from './style';

interface Props {
  selected: IUserGroupCandidate[];
  onRemove: (id: number) => void;
  onClear: () => void;
}

function SelectedList({ selected, onRemove, onClear }: Props) {
  return (
    <div css={PickerStyle.column}>
      <div css={PickerStyle.columnHead}>
        <h4>선택 {selected.length.toLocaleString('ko')}명</h4>
        <UiComponent.Button
          variant="border"
          color="primary"
          disabled={selected.length === 0}
          onClick={onClear}
        >
          전체 해제
        </UiComponent.Button>
      </div>
      <div css={PickerStyle.selectedScroll}>
        {selected.length === 0 ? (
          <p css={PickerStyle.empty}>왼쪽에서 회원을 선택해주세요</p>
        ) : (
          <ul>
            {selected.map((user) => (
              <li key={user.id} css={PickerStyle.selectedItem}>
                <span>{formatNameWithPhone(user.name, user.phone)}</span>
                <button
                  type="button"
                  css={PickerStyle.removeButton}
                  title="선택 해제"
                  onClick={() => onRemove(user.id)}
                >
                  ✕
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default SelectedList;
